import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLicenses = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_196_5009)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_196_5009",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_196_5009)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.20001 14.2342C6.63585 14.2342 6.15893 14.0394 5.76926 13.6497C5.3796 13.2601 5.18476 12.7832 5.18476 12.219C5.18476 11.6548 5.3796 11.1779 5.76926 10.7882C6.15893 10.3986 6.63585 10.2037 7.20001 10.2037C7.76418 10.2037 8.2411 10.3986 8.63076 10.7882C9.02043 11.1779 9.21526 11.6548 9.21526 12.219C9.21526 12.7832 9.02043 13.2601 8.63076 13.6497C8.2411 14.0394 7.76418 14.2342 7.20001 14.2342ZM7.20001 17.719C5.67435 17.719 4.37626 17.1837 3.30576 16.1132C2.23526 15.0427 1.70001 13.7447 1.70001 12.219C1.70001 10.6933 2.23526 9.39524 3.30576 8.32474C4.37626 7.25424 5.67435 6.71899 7.20001 6.71899C8.23851 6.71899 9.19526 6.99141 10.0703 7.53624C10.9453 8.08124 11.6193 8.80883 12.0923 9.71899H20.8943L23.3943 12.219L19.548 15.7457L17.5923 14.3517L15.8885 15.765L13.6615 14.119H12.3923C12.0693 15.2395 11.4161 16.1196 10.4328 16.7592C9.44943 17.3991 8.37185 17.719 7.20001 17.719ZM7.20001 16.419C8.27568 16.419 9.21026 16.0751 10.0038 15.3872C10.7974 14.6994 11.243 13.8433 11.3405 12.819H14.1078L15.848 14.0902L17.527 12.7112L19.475 14.0845L21.5155 12.194L20.3655 11.019H11.2155C10.918 10.1613 10.4099 9.44691 9.69126 8.87574C8.97276 8.30458 8.14235 8.01899 7.20001 8.01899C6.03335 8.01899 5.04168 8.42733 4.22501 9.24399C3.40835 10.0607 3.00001 11.0523 3.00001 12.219C3.00001 13.3857 3.40835 14.3773 4.22501 15.194C5.04168 16.0107 6.03335 16.419 7.20001 16.419Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_196_5009",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgLicenses;
